module.exports = __webpack_public_path__ + "static/media/5n.dccbf554.jpg";